var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7188 2C16.2794 2 7.64285 2 7.34375 2C6.05141 2 5 3.05141 5 4.34375V19.6562C5 20.9486 6.05141 22 7.34375 22H16.7188C18.0111 22 19.0625 20.9486 19.0625 19.6562V4.34375C19.0625 3.05141 18.0111 2 16.7188 2ZM17.5 19.6562C17.5 20.087 17.1495 20.4375 16.7188 20.4375H7.34375C6.91297 20.4375 6.5625 20.087 6.5625 19.6562V4.34375C6.5625 3.91297 6.91297 3.5625 7.34375 3.5625H8.73551L8.89824 4.04605C9.0052 4.36398 9.30324 4.57812 9.63867 4.57812H14.4238C14.7593 4.57812 15.0573 4.36398 15.1643 4.04605L15.327 3.5625H16.7188C17.1495 3.5625 17.5 3.91297 17.5 4.34375V19.6562Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.21c878ea.svg";
export { ForwardRef as ReactComponent };